import {Component} from '@angular/core';

@Component({
    selector: 'app-home-footer',
    styleUrls: ['./home.footer.component.css'],
    template: `
    <div class="footer clearfix">
        <span class="copyright">Copyright Liquitics Solutions Inc., 2017-2022</span>
    </div>
    `
})
export class HomeFooterComponent {

}
